import React, { forwardRef } from "react";
import { a } from "kremling";

import { CpButton } from "@components";
import { SelectDataItem } from "../common/utils";

export type TriggerMultiProps = {
  isDisabled?: boolean;
  toggle?: () => void;
  triggerIsBlock?: boolean;
  value: SelectDataItem[];
  onBlur?: (e: React.FocusEvent) => void;
  placeholder?: string;
  renderValue?: (value: SelectDataItem[]) => string;
  error?: boolean | string;
};

export const TriggerMulti = forwardRef<HTMLButtonElement, TriggerMultiProps>(
  (props, ref) => {
    const {
      isDisabled,
      toggle,
      triggerIsBlock,
      value,
      onBlur,
      placeholder,
      renderValue,
      error,
    } = props;

    let display = placeholder;
    if (value.length) {
      if (renderValue) {
        display = renderValue(value);
      } else {
        if (value.length > 1) {
          display = `${value.length} Selected`;
        } else {
          display = value[0].name;
        }
      }
    }
    return (
      <CpButton
        type="button"
        className={a("trigger-single")
          .m("trigger-single--placeholder", !value.length)
          .m("trigger-single--error", error)}
        onClick={toggle}
        dropdown
        block={triggerIsBlock}
        ref={ref}
        disabled={isDisabled}
        onBlur={onBlur}
      >
        {display}
      </CpButton>
    );
  },
);
